exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-btn-icon-OCr1V{margin:-3px -3px 0;-webkit-user-drag:none}", ""]);

// Exports
exports.locals = {
	"btn-icon": "index-btn-icon-OCr1V"
};